import React from 'react';
import Listview from "../../../core/form/components/Listview";

const ChartLayersCeaSocLsv = (props) => {
  let {
    data,
    colours,
    namePrefix,
    calculationStyle
  } = props;


  // Render Rows
  const renderRows = (headers, dataset) => {
    let rowColour = "mr-3"

    const tableTd = headers.map((header, index) => {
      const classes = `${rowColour} ${header.classes}`;
      const nameClasses = `${classes} text-white`;
      const bgColour = colours[dataset.name];

      const name = `${namePrefix}${dataset[header.field]}`;
      
      switch (header.field) {
        case 'name': return  (
          <td key={index} className={nameClasses} style={{backgroundColor: bgColour, borderRight: '1px solid #cccccc'}}>{name}</td>
        )
        default: return  (
          <td key={index} className={classes} style={{borderRight: '1px solid #cccccc'}}>{dataset[header.field]}</td>
        )
      }
    });

    return tableTd;
  }

  // Upper Headers
  const upperHeaders = [
    {caption: null, cells: 1, classes: 'border-bottom-0'},
    {caption: "Summary", cells: 2, classes: 'text-center text-white bg-primary border border-secondary'}
  ]

  // Lower Headers
  const headers = [
    {caption: 'Name', field: 'name', classes:'text-left'},
    {caption: 'Tot (k)', field: 'carbon_mass', classes:'text-end'},
    {caption: 'Var (k)', field: 'var_carbon_mass', classes:'text-end'},
  ]

  // Build pivot headers and data
  let rows = [];
  const toFixed = 0;
  const divideBy = 1000;

  if (data.length > 0) {
    rows = data.map((row, idx) => {
      const newRow = {
        name: row.area.name,
        carbon_mass: (row[calculationStyle].carbon_mass ? (row[calculationStyle].carbon_mass / divideBy).toFixed(toFixed) : 0 ),
        var_carbon_mass: (row[calculationStyle].var_carbon_mass ? (row[calculationStyle].var_carbon_mass / divideBy).toFixed(toFixed) : 0 )
      }

      row.layers.map(layer => {
        const column = `${layer.layer_upper_depth}-${layer.layer_lower_depth}`;
  
        // Avg soc
        const avgsocFieldName = `${column}_avg_soc`;
        const avgsocCaption = `Tot (k)`;
        newRow[avgsocFieldName] = (layer[calculationStyle].carbon_mass ? (layer[calculationStyle].carbon_mass / divideBy).toFixed(toFixed) : 0);
  
        // Avg soc
        const varianceFieldName = `${column}_var_soc`;
        const varianceCaption = `Var (k)`;
        newRow[varianceFieldName] = (layer[calculationStyle].var_carbon_mass ? (layer[calculationStyle].var_carbon_mass / divideBy).toFixed(toFixed) : 0);
  
        // Add headers (once)
        if (idx === 0) {
          headers.push({caption: avgsocCaption, field: avgsocFieldName, classes:'text-end'});
          headers.push({caption: varianceCaption, field: varianceFieldName, classes:'text-end'});
  
          const upperCaption = `${column}`
          upperHeaders.push(
            {caption: upperCaption, cells: 2, classes: 'text-center bg-lightgray border border-secondary'}
          )
        }
        return false;
      }) 
      return (newRow)
    })
  }

  // Upper header cells
  const upperHeadTh = upperHeaders.map((upperHeader, index) =>
    <th key={index} colSpan={upperHeader.cells} className={upperHeader.classes}>{upperHeader.caption}</th>
  );

  // Lower header cells
  const tableHeadTh = headers.map((header, index) =>
    <th key={index} className={header.classes} style={{borderRight: '1px solid #cccccc'}}>{header.caption}</th>
  );

  let tableBodyTr = (<tr></tr>);
  if (rows && rows.length > 0) {
    tableBodyTr = rows.map((dataset, index) =>
      <tr key={index} >
        {renderRows(headers, dataset)}
      </tr>
    );
  }

  const iconName='leaf';
  const emptyCaption=`No ${namePrefix}'s for this round found...`;

  return (
    <React.Fragment>
      <div className="text-end text-danger">
        <small>Calculated using {calculationStyle}</small>
      </div>
      <Listview rows={rows} upperHeadTh={upperHeadTh} tableHeadTh={tableHeadTh} tableBodyTr={tableBodyTr} iconName={iconName} emptyCaption={emptyCaption}/>
    </React.Fragment>
  )
}

export default ChartLayersCeaSocLsv;
